export const i18n = {
  defaultLocale: 'el',
  locales: ['en-US', 'el'],
} as const;

export type Locale = (typeof i18n)['locales'][number];
